"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeArrayItemWithId = exports.arraySaveDelete = exports.arraySavePush = exports.getCompareVal = exports.updateArrayItemWithId = void 0;
function updateArrayItemWithId(arr, id, change) {
    var i = 0;
    var foundItem = false;
    for (; i < arr.length; ++i) {
        if (arr[i].id === id) {
            foundItem = true;
            break;
        }
    }
    if (!foundItem)
        return arr;
    var newItem = __assign(__assign({}, arr[i]), change);
    var res = __spreadArray([], arr, true);
    res.splice(i, 1, newItem);
    return res;
}
exports.updateArrayItemWithId = updateArrayItemWithId;
function getCompareVal(a, b) {
    if (a === b)
        return 0;
    if (a < b)
        return -1;
    else
        return 1;
}
exports.getCompareVal = getCompareVal;
function arraySavePush(arr, ele) {
    // TODO this method is log N times more expensive than just iterating over all values
    var s = new Set(arr);
    s.add(ele);
    return Array.from(s);
}
exports.arraySavePush = arraySavePush;
function arraySaveDelete(arr, ele) {
    // TODO this method is log N times more expensive than just iterating over all values
    var s = new Set(arr);
    s.delete(ele);
    return Array.from(s);
}
exports.arraySaveDelete = arraySaveDelete;
function removeArrayItemWithId(arr, id) {
    var i = 0;
    var foundItem = false;
    for (; i < arr.length; ++i) {
        if (arr[i].id === id) {
            foundItem = true;
            break;
        }
    }
    if (!foundItem)
        return arr;
    var res = __spreadArray([], arr, true);
    res.splice(i, 1);
    return res;
}
exports.removeArrayItemWithId = removeArrayItemWithId;
